import * as React from "react";
import type { SVGProps } from "react";
const SvgChartBreakoutCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M2.967 13.726c4.536 0 10.773.567 11.34-3.402m0 0h-3.402m3.402 0V14.4m-.078-12v2.447M21.6 9.771h-2.447m.18-5.103-1.624 1.62M9.6 2.703C5.46 3.768 2.4 7.527 2.4 12a9.6 9.6 0 0 0 9.6 9.6c4.687 0 8.589-3.359 9.432-7.8"
    />
  </svg>
);
export default SvgChartBreakoutCircle;
